<script>
import SelectField from '@phoenix/mixins/components/form/fields/SelectField';
import { useField } from '@phoenix/composables/field';
import { PhxIcon } from '@phx-styleguides/iwc';
import InputWrapper from '@maison/components/form/InputWrapper.vue';

export default {
  components: {
    InputWrapper,
    PhxIcon,
  },

  mixins: [SelectField],

  setup(props) {
    return useField(props);
  },

  computed: {
    selectFieldClasses() {
      return [...this.fieldClasses, 'input--select input-wrapper__input'];
    },
  },
};
</script>

<template>
  <input-wrapper class="input-wrapper-select">
    <template #default>
      <select
        :id="fieldUniqueId"
        v-model="value"
        :name="field.name"
        :class="selectFieldClasses"
        :aria-describedby="ariaDescribedby"
        :aria-label="field.ariaLabel"
        :disabled="field.disabled"
        autocomplete="disabled"
      >
        <option v-if="emptyChoice" value="">{{ field.placeholder }}</option>

        <optgroup v-for="(options, label) in groupedOptions" :key="label" :label="label">
          <option v-for="(option, index) in options" :key="`${label}-${index}`" :value="option.value">
            {{ option.label }}
          </option>
        </optgroup>

        <option v-for="(option, index) in options" :key="index" :value="option.value">
          {{ option.label }}
        </option>
      </select>
    </template>

    <template #end-adornment>
      <phx-icon icon="chevron-down" />
    </template>
  </input-wrapper>
</template>
